import type { Dict } from "../core.js";
import type { revenue as vi } from "../vi/revenue.js";

export const revenue: Dict<typeof vi> = {
  title: "Revenue",
  subtitle: "Recognized revenue — total collected in the period, split by currency.",
  loadFailed: "Couldn't load revenue metrics.",
  aggregateNote: "totals per currency, summed across every app with a money ledger.",
  emptyTitle: "No transactions in this period.",
  emptyBefore: "This means « no data yet »,",
  emptyStrong: "not",
  emptyAfter: "zero revenue — the hub can only read money from sources that keep invoice records.",
  recognizedIn: "Recognized revenue ({currency})",
  recurringNotComputed: "Not computable for this period yet.",
  noRecurringBefore: "No source can compute",
  noRecurringStrong: "recurring revenue",
  noRecurringAfter:
    ". « MRR » only appears once a source declares plan price, billing cycle and subscription status — inferring it from paid invoices is reverse-engineering, and breaks with every discount or annual billing period.",
  unmappedPlansAt: "Plans not yet mapped to the shared axis are under",
  planMappingLink: "Plan mapping",
  gapsTitle: "Sources not yet measurable",
};
